import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { UnregisterCallback } from 'history';
import { useHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { history } from 'instantsearch.js/es/lib/routers';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchAllContent } from '../../components';

import './style.scss';

const SEARCH_PAGE_HITS_PER_PAGE = 10;

const Search = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'pages.search' });

  const routerHistory = useHistory();
  const removeHistoryListener = useRef<UnregisterCallback>();

  const routing = {
    router: history({
      start: (onUpdate) => {
        removeHistoryListener.current = routerHistory.listen(onUpdate);
      },
      dispose: () => removeHistoryListener.current,
    }),
  };

  return (
    <div className="Search">
      <Helmet>
        <title>{t('title')}</title>
      </Helmet>
      <Container>
        <SearchAllContent routing={routing} hitsPerPage={SEARCH_PAGE_HITS_PER_PAGE}>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-1">
              <h1 className="Search__title">{t('title')}</h1>
            </div>

            <div className="col-12 col-md-10 offset-md-1">
              <SearchAllContent.SearchBar title={t('body')} />
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-4 offset-lg-1 Search__facets">
              <SearchAllContent.Facets />
              <SearchAllContent.ActiveFacets />
            </div>

            <div className="col-12 col-md-10 offset-md-1 col-lg-6">
              <h2 className="visually-hidden">
                {t('results_title')}
              </h2>
              <SearchAllContent.Stats />
              <SearchAllContent.Results />
              <SearchAllContent.Pagination />
            </div>
          </div>
        </SearchAllContent>
      </Container>
    </div>
  );
};

export default Search;
